import { Transactor, buildTransactorFromDetail } from "../person/Transactor"

export class Employee {
    transactor_id: number
    transactor: Transactor
    isEnable?: boolean
    constructor(id: number, tr: Transactor) {
        this.transactor_id = id
        this.transactor = tr
    }
}

export function buildEmployeeFromDetail(e: any): Employee {
    return new Employee(e.transactor_id,
        buildTransactorFromDetail(e.transactor))
}